/**
 * PATH: apps/quote/src/components/builder/scope-sheet-grid/scope-sheet-utils.ts
 * PURPOSE: Data-transformation helpers for the scope sheet grid.
 */

import type { QuoteSection } from '@/lib/quoteApi'
import type { GridRowType } from './ScopeSheetGridTypes'

/**
 * Flatten sections into a linear row array for virtualisation.
 * Respects collapse state and optional section-focus filter.
 */
export function flattenToRows(
  sections: QuoteSection[],
  collapsedIds: Set<string>,
  focusedSectionId: string | null = null
): GridRowType[] {
  const rows: GridRowType[] = []
  let flatRowIndex = 0

  const sectionsToRender = focusedSectionId
    ? sections.filter((s) => s.id === focusedSectionId)
    : sections

  for (const section of sectionsToRender) {
    rows.push({ type: 'section-header', section })

    const isCollapsed = focusedSectionId ? false : collapsedIds.has(section.id)

    if (!isCollapsed) {
      const items = section.items ?? []
      items.forEach((item, index) => {
        rows.push({ type: 'line-item', section, item, index, flatRowIndex })
        flatRowIndex++
      })
      rows.push({ type: 'phantom', section })
    }
  }

  return rows
}
